export default function changeOptionsAdditional() {
  $(".js-select-options-additional input").on("click", function () {
    const $this = $(this);
    const parentElement = $this.parents("li");

    $this.addClass("selected-option-additional");
    parentElement
      .siblings()
      .find("input")
      .removeClass("selected-option-additional");
  });
}

changeOptionsAdditional();
